import classNames from 'classnames';
import { type ReactNode } from 'react';

import { BrandXL, DisplayXL } from '#src/atoms/typography/index.tsx';
import { FrameCorners } from '#src/atoms/ui/FrameCorners/index.tsx';
import type { Color } from '#src/style/types.ts';

export const S27TitleDisplay = ({
  children,
  color,
}: {
  children: ReactNode;
  color?: Color;
}) => (
  <DisplayXL as="span" color={color}>
    {children}
  </DisplayXL>
);

type Props = {
  children: ReactNode;
  icon?: ReactNode;
  className?: string;
  color?: Color;
};
export const S27Title = ({
  children,
  icon,
  className,
  color = 'var(--c-white)',
}: Props) => {
  return (
    <div className={classNames('relative px-2 py-1', className)}>
      <FrameCorners cornerSize={8} color={color} />
      <div className="flex gap-0.5 items-center">
        {icon}
        <BrandXL as="span" color={color}>
          {children}
        </BrandXL>
      </div>
    </div>
  );
};
